import { Component, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-forms-confirm-registration',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './forms-confirm-registration.component.html',
  styleUrl: './forms-confirm-registration.component.css'
})
export class FormsConfirmRegistrationComponent {
  private readonly authService: AuthService = inject(AuthService);
  private readonly router: Router = inject(Router);
  private readonly route: ActivatedRoute = inject(ActivatedRoute);


  email = '';
  verificationCode = '';
  isLoading = false;
  errorMessage: string | null = null;
  successMessage: string | null = null;

  ngOnInit() {
    console.log("hOLA")
    this.route.queryParams.subscribe(params => {
      this.email = params['email'] ?? '';
      if (!this.email) {
        this.router.navigate(['/register']);
      }
    });
  }

  async confirmSignup() {
    if (!this.verificationCode) {
      this.errorMessage = 'Por favor ingresa el código de verificación';
      return;
    }

    this.isLoading = true;
    this.errorMessage = null;

    try {
      await this.authService.confirmSignUp(this.email, this.verificationCode);
      this.successMessage = '¡Registro confirmado correctamente! Redirigiendo...';
      
      setTimeout(() => {
        this.router.navigate(['/loggin']);
      }, 2000);
    } catch (error: unknown) {
      this.errorMessage = error instanceof Error ? error.message : 'Ocurrió un error al confirmar el registro';
    } finally {
      this.isLoading = false;
    }
  }

  async resendCode() {
  this.isLoading = true;
  this.errorMessage = null;
  
  try {
    await this.authService.resendConfirmationCode(this.email);
    this.successMessage = 'Se ha reenviado el código de verificación a tu correo';
    setTimeout(() => this.successMessage = null, 5000);
  } catch (error: unknown) {
    this.errorMessage = this.getErrorMessage(error);
  } finally {
    this.isLoading = false;
  }
}

private getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    if (error.message.includes('LimitExceededException')) {
      return 'Has excedido el límite de intentos. Por favor espera antes de solicitar otro código.';
    }
    return error.message || 'Error al reenviar el código';
  }
  return 'Error desconocido al reenviar el código';
}
}